import TextField, { type TextFieldProps } from '@/components/TextField';
import { formatNumber } from '@/utils/strings';
import { useToggle } from '@/hooks/useToggle';
import { styles } from './utils';

export type NumberInputProps<N extends string> = {
  disabled?: boolean;
  sx?: TextFieldProps<N>['sx'];
  className?: string;
  name: N;
  label: string;
  value: string;
  onChange: (value: Record<N, string>) => void;
};

export default function NumberInput<N extends string>({
  disabled,
  sx = {},
  className = '',
  name,
  label,
  value,
  onChange,
}: NumberInputProps<N>) {
  const [invalid, toggleInvalid] = useToggle(false);

  const handleChange: TextFieldProps<N>['onChange'] = (update) => {
    if (/^[0-9\s,.]*$/.test(update[name])) {
      toggleInvalid(false);
      onChange(update);
    } else {
      toggleInvalid(true);
    }
  };

  return (
    <TextField
      error={invalid}
      disabled={disabled}
      className={className}
      sx={{ ...styles.textField, ...sx }}
      value={value}
      name={name}
      label={label}
      placeholder={formatNumber(1234.56)}
      inputProps={{
        pattern: '[0-9\s,\.]*',
      }}
      onChange={handleChange}
    />
  );
}
